const initialState = {
	accountDetail: null,
	selectedAccount: null,
	selectedPriceSource: null,
	usersOfAccount: null,
	userDetails: null,
	approvedAccounts: null,
	addressList: null,
	jobSiteAddressList: [],
	customerShipToDetailsAddressList: null,
	customerShipToDetailsAddressListForOrder: null,
	selectedAddress: null,
	selectedAccountsAllPriceSources: null,
	userProfile: null,
	orgContactPointList: null,
	userContactPointList: null,
	addressAttributes: null,
	relationShipPartyList: null,
	allTcaList: null,
	userOtherDetails: null,
	localUserDetails: null,
	notificationTypeListBkp: null,
	isSessionExpired: false,
	addressExceptionDispatch:false,
	accountResponsibilityData: null,
	shippingAddressDetailsListWithZipCode: [],
	inValidLoginAttempts: 0,
	geAdBuilderData: null,
	encryptedAcbData:null,
	roleList: null,
	// dDTSalesAgreementList: null,
	defaultSelectedADC: '',
	selectedADC: '',
	lastLoginUpdate : false,
	factoryDirectList:[{
		label: 'LOU',
		name: 'Louisville',
	},{
		label: 'LRD',
		name: 'Laredo Crossdock',
	},{
		label: 'DPO',
		name: 'Decatur Factory',
	}],
	adcList: [{
		label: 'ATL',
		name: 'Atlanta',
	}, {
		label: 'BAL',
		name: 'Baltimore',
	}, {
		label: 'CHI',
		name: 'Chicago',
	}, {
		label: 'DAL',
		name: 'Dallas',
	}, {
		label: 'DEN',
		name: 'Denver',
	}, {
		label: 'JAX',
		name: 'Jacksonville',
	}, {
		label: 'LAX',
		name: 'Los Angeles',
	}, {
		label: 'LOU',
		name: 'Louisville',
	}, {
		label: 'SEA',
		name: 'Seattle',
	}, {
		label: 'CH2',
		name: 'Satellite CHI',
	}, {
		label: 'FON',
		name: 'Satellite CHI',
	}, {
		label: "SAC",
		name:"Sacramento"
	}],
	// TO DO: Static list
	inventoryFinancingList: ["wells fargo", "northpoint", "brandsource", "north point", "brand source"],
	allowedCreditTypesList: ["As-is Credit/Rebill", "Price Adjustment - Credit/Rebill", "Scrap", "Damage Allowances", "Delivery/Services/Fees", "Push/Pull Credit"],
	allowedCreditTypesListForManageUser: ["Scrap", "Damage Allowances", "Delivery/Services/Fees", "As-is Credit/Rebill", "Push/Pull Credit", "No Charge Replacement Parts orders"],
	// TO DO: Static list
	notificationTypeList: [
		{ label: 'Order Acknowledgement', shortValue: 'ORDER ACKNOWLEDGEMENT WO PRICE', value: 'Order Acknowledgement', checked: false },
		{ label: 'Backorder', shortValue: 'BACK ORDER NOTIFICATION', value: 'Backorder', checked: false },
		{ label: 'Will Call', shortValue: 'WILL CALL NOTIFICATION', value: 'Will Call', checked: false },
		{ label: 'Preshipment', shortValue: 'PRE-SHIPMENT NOTIFICATION', value: 'Preshipment', checked: false },
		{ label: 'Pricing', shortValue: 'PRICE NOTIFICATION PRIMARY', value: 'Pricing', checked: false },
		{ label: 'Return Authorization', shortValue: 'RETURN NOTIFICATION', value: 'Return Authorization', checked: false },
		{ label: 'Serial List', shortValue: 'SERIAL LIST NOTIFICATION', value: 'Serial List', checked: false },
		{ label: 'Cut Notification', shortValue: 'CANCELLED CUT NOTIFICATION', value: 'Cancelled Cut Notification', checked: false },
		{ label: 'Reservation Notification', shortValue: 'ORDER RESERVATION NOTIFICATION', value: 'Reservation Notification', checked: false },
		{ label: 'SDS Proof of Delivery', shortValue: 'EPOD', value: 'SDS Proof of Delivery', checked: false },
	],
	// TO DO: Static list
	responsibilities: [
		{ label: 'Price', value: 'Price', checked: false },
		{ label: 'Price Discounts', value: 'Price Discounts', checked: false },
		{ label: 'View Orders', value: 'View Orders', checked: false },
		{ label: 'Create New Order', value: 'Create New Order', checked: false },
		{ label: 'Edit Orders', value: 'Edit Orders', checked: false },
		{ label: 'Returns', value: 'Returns', checked: false },
		{ label: 'Invoices And Payments', value: 'Invoices And Payments', checked: false }
	],
	// static list in case of unchecking previously selected notification item
	unCheckNotificationMapping: [
		{ notification: "ORDER ACKNOWLEDGEMENT WO PRICE", value: "CNET1" },
		{ notification: "ORDER ACKNOWLEDGEMENT W PRICE", value: "CNET1" },
		{ notification: "BACK ORDER NOTIFICATION", value: "CNET2" },
		{ notification: "WILL CALL NOTIFICATION", value: "CNET3" },
		{ notification: "PRE-SHIPMENT NOTIFICATION", value: "CNET4" },
		{ notification: "PRICE NOTIFICATION PRIMARY", value: "CNET5" },
		{ notification: "RETURN NOTIFICATION", value: "CNET6" },
		{ notification: "CREDIT NOTIFICATION", value: "CNET7" },
		{ notification: "SERIAL LIST NOTIFICATION", value: "CNET8" },
		{ notification: "CANCELLED CUT NOTIFICATION", value: "CNET9" },
		{ notification: "ORDER RESERVATION NOTIFICATION", value: "CNET10" },
		{ notification: "EPOD", value: "CNET11" }
	],
	allSelectedAccountsAllPriceSources: [],
	isDpmAccount: false
};

export default function user(state = initialState, action) {
    switch (action.type) {
		case 'SELECT_ALL_NOTIFICATION_LIST':
			var notificationTypeList = state.notificationTypeList;
			notificationTypeList.map((item) => {
				item.checked = action.data
				return null;
			});
			return {
                ...state,
				notificationTypeList: notificationTypeList
			};
		case 'SET_DEFAULT_ADC':
			return {
				...state,
				defaultSelectedADC: action.data
			};
		case 'SET_SELECTED_ADC':
			return {
				...state,
				selectedADC: action.data
			};
		case 'SAVE_ACCOUNT_RESPONSIBILITY_DATA':
			return {
				...state,
				accountResponsibilityData: action.data
			};
		case 'SAVE_INVALID_LOGIN_ATTEMPTS':
			return {
				...state,
				inValidLoginAttempts: action.data
			};
		case 'SAVE_USER_PENDING_REQUESTS':
			return {
                ...state,
				userPendingRequests: action.data
			};
		case 'SAVE_GE_AD_BUILDER_KEY':
			return {
				...state,
				geAdBuilderData: action.data
			};
		case 'SAVE_ENCRYPTED_ACB':
			return {
				...state,
				encryptedAcbData: action.data
			};
		case 'UPDATE_SELECTED_ADDRESS':
			return {
				...state,
				selectedAddress: action.data
			}
		case 'SAVE_ROLE_LIST':
			return {
				...state,
				roleList: action.data
			};
		case 'UPDATE_NOTIFICATION':
			notificationTypeList = state.notificationTypeList;
			notificationTypeList.forEach((item) => {
				const data = action.data.find(itm => itm.notificationType === item.value);
				if(data && item.value === data.notificationType) {
					item.checked = data.bool;
				}
			});
			return {
                ...state,
				notificationTypeList: notificationTypeList
			};
		case 'SAVE_ACCOUNT_DETAIL':
			return {
				...state,
				accountDetail: action.data
			}
		case 'SAVE_USER_PROFILE':
			if(action.data && action.data.responseObject && action.data.responseObject.length > 0) {
				action.data = action.data.responseObject[0];
			}
			return {
				...state,
				userProfile: action.data
			}
		case 'SAVE_ADDRESS_LIST':
			return {
				...state,
				addressList: action.data
			}
		case 'SAVE_CUSTOMER_SHIP_TO_DETAILS':
			return {
				...state,
				customerShipToDetailsAddressList: action.data
			}
		case 'SAVE_ALL_JOB_SITE_ADDRESS_LIST':
			return {
				...state,
				jobSiteAddressList: state.jobSiteAddressList.concat(action.data)
			};
		case 'SAVE_CUSTOMER_SHIP_TO_DETAILS_FOR_ORDER':
			return {
				...state,
				customerShipToDetailsAddressListForOrder: action.data
			}
		case 'SAVE_SELECTED_ADDRESS_BACKUP':
			return {
				...state,
				selectedAddressBackup: action.data
			}
		case 'SAVE_ADDRESS_ATTRIBUTES':
			return {
				...state,
				addressAttributes: action.data
			}
		case 'SAVE_RELATION_SHIP_PARTY_LIST':
			return {
				...state,
				relationShipPartyList: action.data
			}
		case 'SAVE_ALL_TCA_LIST':
			return {
				...state,
				allTcaList: action.data
			}
		case 'SAVE_ALL_ADJ_PRC_MOD':
			return {
				...state,
				allAdjPrcModList: action.data
			}
		case 'SAVE_USERS_OF_ACCOUNT':
			return {
				...state,
				usersOfAccount: action.data
			}
		case 'SAVE_SELECTED_ACCOUNT_ASM_DETAILS':
			return {
				...state,
				selectedAccountAsmDetails: action.data
			}
		case 'SAVE_ACCOUNT_DETAIL_POST_LOGIN':
    	    return {
                ...state,
    	        accountDetail: action.data
    	    };
		case 'SAVE_APPROVED_ACCOUNT_DETAILS':
			return {
                ...state,
				approvedAccounts: action.data
			};
		case 'BACKUP_NOTIFICATION_LIST':
			return {
                ...state,
				notificationTypeListBkp: JSON.parse(JSON.stringify(state.notificationTypeList))
			};
		case 'SAVE_SELECTED_ACCOUNTS_ALL_PRICE_SOURCES':
			return {
                ...state,
				selectedAccountsAllPriceSources: action.data
			};
		case 'SAVE_SELECTED_ACCOUNTS_ALL_PRICE_SOURCES_WITHOUT_FILTER':
			return {
                ...state,
				allSelectedAccountsAllPriceSources: action.data
			};
		case 'SAVE_ACCOUNT_AND_PRICE_SOURCE':
 	        return {
                ...state,
 	            selectedAccount: action.data.selectedAccount,
 	            selectedPriceSource: action.data.selectedPriceSource
 	        }
		case 'SAVE_USER_OTHER_DETAILS':
			return {
				...state,
				userOtherDetails: action.data
			}
			case 'Last_Login_Update':
				return {
				...state,
				lastLoginUpdate: action.data
				}
			case 'SAVE_USER_DETAILS':
				var gessouid = state.userDetails && state.userDetails.gessouid?state.userDetails.gessouid:action.data.gessouid,
				typeOfUser = state.userDetails && state.userDetails.typeOfUser?state.userDetails.typeOfUser:action.data.typeOfUser;
				
				return {
					...state,
					userDetails: {
						...state.userDetails,
						firstName: action.data.firstName,
						lastName: action.data.lastName,
						sso: action.data.sso,
						email: action.data.email,
						validUser: action.data.validUser,
						gessouid: gessouid,
						typeOfUser: typeOfUser,
						isASM: action.data.isASM,
						otherASM: action.data.otherASM,
						isInDL: action.data.isInDL,
						isSiteManagementAccess: action.data.isSiteManagementAccess,
						isAdmin: action.data.isAdmin,
						jwt: action.data.jwt,
						entryDN: action.data.entryDN,
						adminAccess : action.data.adminAccess,
						manageSiteAccess : action.data.manageSiteAccess,
						punchOutAccess : action.data.punchOutAccess,
						punchOutAccNumber : action.data.punchOutAccNumber,
						punchOutSalesNumber : action.data.punchOutSalesNumber,
						punchoutRedirectUrl: action.data.punchoutRedirectUrl,
						punchoutPostUrl: action.data.punchoutPostUrl,
						punchoutBuyerCookie: action.data.punchoutBuyerCookie,
						punchoutFromIdentity: action.data.punchoutFromIdentity,
						punchoutToIdentity: action.data.punchoutToIdentity,
						punchoutSenderIdentity: action.data.punchoutSenderIdentity,
						punchoutSenderPassword: action.data.punchoutSenderPassword,
						punchoutUserAgent: action.data.punchoutUserAgent,
						payloadID: action.data.payloadID,
						isNonGEASsoUser: action.data.isNonGEASsoUser,
						isManRepSsoUser: action.data.isManRepSsoUser,
						omAccess : action.data.omAccess,
						isOktaLogin : action.data.isOktaLogin,
					}
				}
		case 'UPDATE_USER_ASM_OR_NOT':
			return {
				...state,
				userDetails: {
					...state.userDetails,
					isASM: action.data
				}
			}
		case 'UPDATE_USER_ASM_OF_OTHER_ACCOUNT':
			let isASM = false;
			if(action.data && action.data.responseObject && action.data.responseObject.length) {
				isASM = action.data.responseObject.find(itm => itm.SALESREP_NUMBER === state.userDetails.sso) ? true : false;
			}
			return {
				...state,
				userDetails: {
					...state.userDetails,
					otherASM: isASM
				}
			}
		case 'UPDATE_USER_IS_IN_DL_OR_NOT':
			return {
				...state,
				userDetails: {
					...state.userDetails,
					isInDL: action.data && action.data.responseObject ? true : false
				}
			}
		case 'SAVE_MANAGE_SITE_ACCESS':
			return {
				...state,
				userDetails: {
					...state.userDetails,
					isSiteManagementAccess: action.data && action.data.responseObject ? true : false
				}
			}
		case 'UPDATE_USER_ADMIN_OR_NOT':
			return {
				...state,
				userDetails: {
					...state.userDetails,
					isAdmin: action.data
				}
			}
		case 'SAVE_LOCAL_USER_DETAILS':
			return {
				...state,
				localUserDetails: action.data
			}
		case 'SAVE_ORG_CONTACT_POINT_LIST':
            return {
                ...state,
                orgContactPointList: action.data
            }
		case 'SAVE_USER_CONTACT_POINT_LIST':
			return {
				...state,
				userContactPointList: action.data
			}
		case 'RESET_SHIPPING_ADDRESSES':
			return {
				...state,
				shippingAddressDetailsListWithZipCode: []
			}
		case 'SAVE_SHIPPING_ADDRESSES':
			const data = state.shippingAddressDetailsListWithZipCode;
			data.push(action.data);
			return {
				...state,
				shippingAddressDetailsListWithZipCode: data
			}
		case 'UPDATE_SHIPPING_ADDRESSES':
			return {
				...state,
				shippingAddressDetailsListWithZipCode: action.data
			}
		case 'UPDATE_SESSION_STATUS':
			return {
				...state,
				isSessionExpired: action.data
			}
		case 'RESET_USER_DETAILS':
            return {
                ...state,
                userDetails: null
            }
		case 'ADDRESS_EXCEPTION_DISPATCH':
			return { ...state,
				addressExceptionDispatch: action.data
			};
		case 'SAVE_GENERIC_NCRP_ACCOUNT':
			return {
				...state,
				genericNCRPAccount: {
					...state.genericNCRPAccount,
					...action.data
				}
			};
		case 'SET_IS_DPM_ACCOUNT':
			return {
				...state,
				isDpmAccount: action.data
			};
		case 'RESET_USER_REDUCERS':
			return initialState;
	    default:
	        return state;
    }
}



// WEBPACK FOOTER //
// ./src/App/redux/reducers/user.js